/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateEventDto
 */
export interface UpdateEventDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEventDto
     */
    name: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEventDto
     */
    categIds: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateEventDto
     */
    userId: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventDto
     */
    start: string | null;
    /**
     * 
     * @type {object}
     * @memberof UpdateEventDto
     */
    partnerIds: object | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEventDto
     */
    duration: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEventDto
     */
    partnerSelected: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventDto
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEventDto
     */
    location?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEventDto
     */
    contextTracking?: boolean;
}

/**
 * Check if a given object implements the UpdateEventDto interface.
 */
export function instanceOfUpdateEventDto(value: object): value is UpdateEventDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categIds' in value) || value['categIds'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('partnerIds' in value) || value['partnerIds'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('partnerSelected' in value) || value['partnerSelected'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function UpdateEventDtoFromJSON(json: any): UpdateEventDto {
    return UpdateEventDtoFromJSONTyped(json, false);
}

export function UpdateEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'categIds': json['categ_ids'],
        'userId': json['user_id'],
        'start': json['start'],
        'partnerIds': json['partner_ids'],
        'duration': json['duration'],
        'partnerSelected': json['partner_selected'],
        'description': json['description'],
        'location': json['location'] == null ? undefined : json['location'],
        'contextTracking': json['contextTracking'] == null ? undefined : json['contextTracking'],
    };
}

export function UpdateEventDtoToJSON(json: any): UpdateEventDto {
    return UpdateEventDtoToJSONTyped(json, false);
}

export function UpdateEventDtoToJSONTyped(value?: UpdateEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'categ_ids': value['categIds'],
        'user_id': value['userId'],
        'start': value['start'],
        'partner_ids': value['partnerIds'],
        'duration': value['duration'],
        'partner_selected': value['partnerSelected'],
        'description': value['description'],
        'location': value['location'],
        'contextTracking': value['contextTracking'],
    };
}

